import { render, staticRenderFns } from "./noJoin.vue?vue&type=template&id=07522e4f&scoped=true&"
import script from "./noJoin.vue?vue&type=script&lang=js&"
export * from "./noJoin.vue?vue&type=script&lang=js&"
import style0 from "./noJoin.vue?vue&type=style&index=0&id=07522e4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07522e4f",
  null
  
)

export default component.exports